import { useTranslation } from 'react-i18next';
import { formatCurrency } from '~/utils';

export function SellerOrderSummaryCard({ orderTotal }: { orderTotal: number }) {
  const { t } = useTranslation('order');

  return (
    <div className="bg-white rounded-lg border border-gray-200 p-6 shadow-sm">
      <h2 className="text-neut-prim font-semibold mb-4">
        {t('order.order_summary')}
      </h2>
      <div className="space-y-3">
        <div className="flex justify-between text-sm">
          <span className="text-gray-600">{t('order.subtotal')}</span>
          <span className="text-neut-prim font-medium">
            {formatCurrency(orderTotal)}
          </span>
        </div>
        <div className="flex justify-between text-sm">
          <span className="text-gray-600">{t('order.shipping_fee')}</span>
          <span className="text-neut-prim font-medium">$0</span>
        </div>
        <div className="border-t pt-3 flex justify-between">
          <span className="text-neut-prim font-semibold">
            {t('order.total_amount')}
          </span>
          <span className="text-xl text-[#001D21] font-semibold">
            {formatCurrency(orderTotal)}
          </span>
        </div>
      </div>
    </div>
  );
}
